import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query GetCheckoutData($organisationId: ID, $schemeType: ID!, $locale: String) {
    checkoutData(organisationId: $organisationId, schemeType: $schemeType, locale: $locale) {
      currentUser {
        id
        email
        dateOfBirth
        firstName
        lastName
        placeOfWork
        address1
        address2
        homePhone
        mobileNumber
        niNumber
        postcode
        title
        town
        county
      }
      employeeOrganisation(id: $organisationId, locale: $locale) {
        id
        employee {
          id
          employeeNumber
        }
        scheme(schemeTypeRelativeUrl: $schemeType) {
          quoteLimit
          id
          storeName
          showDateOfBirth
          checkboxes {
            name
            content
            required
          }
          basket {
            id
            count
            monthlyPrice
            term
            totalMonthlyGrossAmount
            disposalFee
            endOfAgreementFee
            totalSavings
            totalRrp
            basketItems {
              id
              productId
              name
              link
              quantity
              imageUrl
              price
              totalAmount
              term
              brand
              category
              variant
              sku
              storeName
              department
              supplierName
            }
          }
        }
      }
    }
  }
`

export const getCheckoutDataQueryKey = getQueryNames(query)[0]
export default query
